import { NotificationProvider } from "@storoey/sui";
import {
  createRootRouteWithContext,
  Link,
  Outlet,
} from "@tanstack/solid-router";
import { TanStackRouterDevtools } from "@tanstack/solid-router-devtools";
import { AppNavbar } from "../components/AppNavbar/AppNavbar";
import { NavbarProvider } from "../contexts/RootContext";

export const Route = createRootRouteWithContext()({
  component: RootComponent,
  errorComponent: (props) => {
    const error = () => props.error;
    return (
      <div style={{ padding: "16px" }}>
        <h1>Router error</h1>
        <pre style={{ "white-space": "pre-wrap" }}>{String(error())}</pre>
      </div>
    );
  },
  notFoundComponent: () => {
    return (
      <div>
        <p>This is the notFoundComponent configured on root route</p>
        <Link to="/">Start Over</Link>
      </div>
    );
  },
});

function RootComponent() {
  return (
    <div>
      <NotificationProvider>
        <NavbarProvider>
          <div>
            <AppNavbar />
          </div>
          <Outlet />
        </NavbarProvider>
        {/* Start rendering router matches */}
        <TanStackRouterDevtools position="bottom-right" />
      </NotificationProvider>
    </div>
  );
}
